import { configureStore, Action, AnyAction } from '@reduxjs/toolkit';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import rootReducer, { RootState } from './rootReducer';
import * as Sentry from '@sentry/react';
import { useDispatch } from 'react-redux';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options
});

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
type TypedDispatch<T> = ThunkDispatch<T, any, AnyAction>;
type AppState = ReturnType<typeof rootReducer>;

export const useAppDispatch = () => useDispatch<TypedDispatch<AppState>>();

export default store;
